import moment from 'moment';


export const generalProfileInitialState = {
  generalProfile: {
    ui: {
      favorites: []
    },
    data: [],
    reports: [],
    activeReport: {
      id: null,
      name: '',
      instruction: '',
      result: '',
      date_updated: "TODAY",
      date_created: "TODAY"
    },
    activeReportId: null,
    selectedProfile: {},
    is_loading: false,
    meta: {
      currentPage: 1,
      pages: 1,
      pageSize: 25,
      totalProfiles: 0,
      isLoading: false,
      hasError: false,
      loaded: false,
      profiles: [],
    },
    filters: {
      startDate: moment().utc().subtract(1, 'months')
        .startOf('month')
        .hours(1),
      endDate: moment().utc(),
      filtering: {
        selected: { id: "1", title: "all", value: "all", label: "all" },
        options: [
          { id: "1", title: "all", value: "all", label: "all" },
          { id: "2", title: "gold", value: "gold", label: "gold" },
          { id: "3", title: "silver", value: "silver", label: "silver" },
          { id: "4", title: "bronze", value: "bronze", label: "bronze" },
        ]
      },
      profilefiltering: {
        selected: { id: "1", title: "accounts", value: "accounts", label: "accounts" },
        options: [
          { id: "1", title: "accounts", value: "accounts", label: "accounts" },
          { id: "2", title: "operators", value: "operators", label: "operators" },
          { id: "3", title: "clients", value: "clients", label: "clients" },
        ]
      },
      isDecimal: false,
      search: ''
    }
  }
};
